import { Router, Routes } from '@angular/router';
import { SessionStoreService } from './core/services/session.store.service';
import { inject } from '@angular/core';
import { DASHV1_ROUTES } from './features/dashboardv1/dashboardv1.routes';
import { Rolepermissions } from './features/settings/rolesPersmission/rolepermissions';
import { Insights } from './shared/insights/insights';
import { Questionary } from './shared/insights/questionary/questionary';
import { Roleinsights } from './shared/insights/roleinsights/roleinsights';
import { Widgetlayout } from './features/settings/widgetlayout/widgetlayout';
import { Insightsmasterv2 } from './features/settings/insightsmaster/insightsmaster';

// src/app/app.routes.ts
export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
    canActivate: [
      () => {
        const s = inject(SessionStoreService);
        const r = inject(Router);
        return s.hasPasskey() ? r.createUrlTree(['/passkey/login']) : true;
      },
    ],
  },
  // { path: 'dashboard', loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.DASH_ROUTES) },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./features/dashboardv1/dashboardv1.routes').then(
        (m) => m.DASHV1_ROUTES
      ),
  },
  {
    path: 'passkey',
    loadChildren: () =>
      import('./features/passkey/passkey.routes').then((m) => m.PASSKEY_ROUTES),
  },
  {
    path: 'grpsettings',
    loadChildren: () =>
      import('./features/settings/groups/dashboardgrp.routes').then(
        (m) => m.GRPSETTINGS_ROUTES
      ),
  },
  // {
  //   path:'rolespermissions',loadChildren:() => import('./features/settings/rolesPersmission/rolepermissions').then(m => m.Rolepermissions)
  // },
  { path: 'rolespermissions', component: Rolepermissions },
  {
    path: 'widgetlayout',
    component:  Widgetlayout
  },
  {
    path : 'insightsmaster',
    component: Insightsmasterv2
  },
  {
    path: 'addwidgets',
    loadChildren: () =>
      import('./features/settings/addeditwidgets/addeditwidgets.routes').then(
        (m) => m.Addedit_ROUTES
      ),
  },
  {
    path:'cmsmodule',
    loadChildren:()=>import('./features/settings/cmsmodule/cmsmodule/cmsmodule.routes').then(m=>m.CMS_MODULE)
  },
  {
    path: 'insights',
    component: Insights,
  },
  {
    path:'addInsights',
    component:Questionary
  },
  {
    path:'addroletoinsights',
    component:Roleinsights
  },
  {
    path:'permissions',
    loadChildren:()=>import('./features/settings/permissions/permissions.routes').then((m)=>m.PERMISSION_ROUTES)
  },
  {
    path:'users' , loadComponent: () => import('./features/settings/users/users.component').then(m => m.UsersComponent)
  },
  { path: '**', redirectTo: '' },
];
